import { createSafeContext } from '@mantine/core';

const [SwipeableContainerProvider, useSwipeableContainerContext] = createSafeContext<{
  containerHeight: number;
}>('SwipeableContainerProvider component was not found in tree');

export { SwipeableContainerProvider, useSwipeableContainerContext };
